import { createAPI } from '../../common'

export default {
  postPhotoGrouplistcount: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0g{jowplf0qipupmjtudpvou', 'post', config, {
      neverLoading: true
    }), // 获取图片库列表数据总数
  postPhotoList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0g{jowplf0qipupmjtu', 'post', config, {
      neverLoading: true
    }), // 获取图片列表 config用于是否展示loading层
  postPhotoPhotofv: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0g{jowplf0qipupgw', 'post', config, {
      neverLoading: true
    }), // 获取图片库文件夹
  postPhotoGroup: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0g{jowplf0qipuphspvq', 'post', config, vconfig), // 获取组图详情图片列表  
  getPhotoApiBase: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0g{jowplf0qipupcbtf', 'post', config, {
      neverLoading: true
    }), // 获取图片库配置
  getNewPath: (config, vconfig) =>
      createAPI('customEncryptApiName-1/0nfejby.benjo0qjdGpsxbse0qipup0hfuOfxQbui', 'get', config, {
        timeout: 60000,
        ...vconfig
      }), //获取新图片地址
  postSearchPhotoListCount: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0g{jowplf0tfbsdiqipupmjtudpvou', 'post', config),
  postSearchPhotoList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0g{jowplf0tfbsdiqipupmjtu', 'post', config),    
}
